import React, { useState,useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { motion, AnimatePresence } from "framer-motion"
import {
  FiTag,
  FiMonitor,
  FiCalendar,
  FiMapPin,
  FiLink,
  FiDollarSign,
  FiPlus,
  FiEdit3,
  FiTrash2,
  FiCheck,
  FiUsers,
  FiX,
  FiUpload,
  FiFilter,
  FiSearch,
} from "react-icons/fi"

import { useQuery } from '@tanstack/react-query'
import { fetchTactosPrograms, tactosCreatePrograms, tactosDeletePrograms, tactosUpdatePrograms } from '../utils/api'
const Programs = () => {
    const [activeTab, setActiveTab] = useState("Free")
      const [events, setEvents] = useState([])
      const [showForm, setShowForm] = useState(false)
      const [showFieldModal, setShowFieldModal] = useState(false);
      const [newField, setNewField] = useState({ label: "", type: "text", required: false, for: "" });
      const [showErrors, setShowErrors] = useState(false);
      const [activeMode, setActiveMode] = useState(null);
      const [modeDetails, setModeDetails] = useState({
        Registered: { amount: "", fields: [] },
        NonRegistered: { amount: "", fields: [] },
      });
      const [formData, setFormData] = useState({
        name: "",
        description:"",
        venue:"",
        startDate:"",
        endDate:"",
        for:"",
        expiryDate:""
      })
    
      const fieldTypes = [
        { label: "Text Input", value: "text" },
        { label: "Number", value: "number" },
        { label: "Dropdown", value: "select" },
        { label: "Checkbox", value: "checkbox-group" },
        { label: "Radio", value: "radio" },
        { label: "Date", value: "date" },
        { label: "Time", value: "time" },
        { label: "Date & Time", value: "datetime" },
        { label: "File", value: "file" },
        { label: "Image", value: "image" },
        { label: "Toggle", value: "toggle" },
        { label: "Textarea", value: "textarea" },
      ];
      const [editIndex, setEditIndex] = useState(null)
      const navigate = useNavigate()


        const {data:programs,isLoading,refetch}=useQuery({
          queryKey:['events'],
          queryFn:fetchTactosPrograms
        })
    
      useEffect(() => {
       console.log(programs)
      }, [programs])
    
      // const fetchEvents = async () => {
      //   const res = await fetchTactosEvents()
      //   console.log(res)
      //   setEvents(res)
      // }
    
    
    
      const handleTabChange = (tab) => setActiveTab(tab)
    
      const handleInputChange = (e) => {
        const { name, value } = e.target
        setFormData({ ...formData, [name]: value })
      }
    
     
    const formatDateForInput = (date) => {
  if (!date) return "";
  return new Date(date).toISOString().split("T")[0];
};
    
      const handleEdit = (program) => {
     console.log(program);

  setFormData({
    ...program,
    startDate: formatDateForInput(program.startDate),
    endDate: formatDateForInput(program.endDate),
    expiryDate: formatDateForInput(program.expiryDate),
  });

  setEditIndex(program._id);
  setShowForm(true);
      };
    
     const handleChange = async (e) => {
      const { name, type, checked, files, value } = e.target;
    
      if (name === "logo" && files?.length > 0) {
        let file = files[0];
    
        // Fix WhatsApp .jpe files
        if (file.name.endsWith(".jpe")) {
          file = new File([file], file.name.replace(".jpe", ".jpg"), {
            type: "image/jpeg"
          });
        }
    
        // 🔥 FRONTEND FIX: COMPRESS BEFORE BASE64
        try {
          const compressedFile = await imageCompression(file, {
            maxSizeMB: 0.4,            // Keep base64 under Cloudflare’s limit
            maxWidthOrHeight: 1600,    // Resize large images
            useWebWorker: true
          });
    
          readFileAsBase64(compressedFile);
        } catch (err) {
          console.error("Image compression failed:", err);
        }
    
        return;
      }
    
      setFormData((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      }));
    };
    
    
   
    
   
    

      const tabVariants = {
        inactive: { scale: 1, opacity: 0.7 },
        active: { scale: 1.05, opacity: 1 },
      }
    
      const cardVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0 },
        hover: { y: -5, scale: 1.02 },
      }
    
      const onModalOpenForFields = (data) => {
        setNewField({})
        console.log(data)
        setShowFieldModal(true);
        setNewField({ ...newField, for: data })
    
      }


      const handleFormSubmit = async (e) => {
        e.preventDefault();
      
        
      
        // ✅ DO NOT convert eventMode to a string
        const payload = {
          ...formData,
      
        };
      
        console.log("✅ Final Payload →", payload);
      
        try {
          if (
            !payload.name ||
            !payload.venue ||
            !payload.description ||
            !payload.startDate ||
            !payload.endDate ||
            !payload.for ||
            !payload.expiryDate 
          ) {
            alert("Please fill all required fields");
            return;
          }
      
         if (editIndex !== null) {
          console.log(payload)
          await tactosUpdatePrograms(editIndex, payload);
        } else {
          await tactosCreatePrograms(payload);
        }
      setFormData({...formData,name:"",venue:"",description:"",startDate:"",endDate:"",for:"",expiryDate:""})
          refetch()
          setShowForm(false);
          
        } catch (err) {
          console.error("Form submit failed:", err);
        }
      };


       const handleDelete = async (id) => {
          try {
            await tactosDeletePrograms(id)

             refetch()
          } catch (err) {
            console.error("Delete failed:", err)
          }
        }
    
      useEffect(() => {
        // console.log(modeDetails)
        console.log(formData)
      }, [formData])
  return (
   <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 p-4 sm:p-6 lg:p-8">
      <div className="max-w-7xl mx-auto space-y-8">
        {/* Header Section */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white rounded-3xl p-6"
        >
          <div className="flex flex-col lg:flex-row justify-between items-center gap-6">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl flex items-center justify-center">
                <FiCalendar className="text-white text-xl" />
              </div>
              <div>
                <h1 className="text-3xl font-bold bg-gradient-to-r from-gray-900 to-gray-600 bg-clip-text text-transparent">
                  Tactos Programs
                </h1>
                <p className="text-gray-500 text-sm">Manage your Programs</p>
              </div>
            </div>

            <div className="flex items-center gap-4">
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => setShowForm(true)}
                className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-6 py-3 rounded-xl font-semibold flex items-center gap-2"
              >
                <FiPlus className="text-lg" />
                Add New Program
              </motion.button>
            </div>
          </div>
        </motion.div>

        {/* Tabs Section */}
        {/* <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="flex flex-wrap gap-3 mb-8 p-2 bg-white rounded-2xl"
        >
          {["Free", "Paid", "Completed"].map((tab) => (
            <motion.button
              key={tab}
              variants={tabVariants}
              animate={activeTab === tab ? "active" : "inactive"}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => handleTabChange(tab)}
              className={`px-6 py-3 rounded-xl text-sm font-semibold flex items-center gap-2 ${activeTab === tab
                ? "bg-gradient-to-r from-blue-600 to-purple-600 text-white"
                : "bg-white text-gray-700 hover:bg-gray-50"
                }`}
            >
              <FiFilter className="text-sm" />
              {tab} Events
            </motion.button>
          ))}
        </motion.div> */}

        {/* Events Grid */}
        <motion.div layout className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
          <AnimatePresence>
            {isLoading?Array.from({ length: 1 }).map((_, index) => (
        <motion.div
          key={`skeleton-${index}`}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <AdminEventCardSkeleton />
        </motion.div>
      )):programs?.data?.map((program, index) => (
              <motion.div
                key={program._id}
                variants={cardVariants}
                initial="hidden"
                animate="visible"
                exit="hidden"
                whileHover="hover"
                transition={{ delay: index * 0.1 }}
                className="group bg-white rounded-3xl p-6 relative overflow-hidden"
              >
                {/* Status Badge */}
                {/* <div className="absolute top-4 right-4 z-10">
                  <span
                    className={`px-3 py-1 text-xs font-semibold rounded-full ${event.status === "Completed"
                      ? "bg-emerald-100 text-emerald-700 border border-emerald-200"
                      : event.status === "Ongoing"
                        ? "bg-amber-100 text-amber-700 border border-amber-200"
                        : isEventNew(event.createdAt)
                          ? "bg-blue-100 text-blue-700 border border-blue-200"
                          : "hidden"
                      }`}
                  >
                    {event.status}
                  </span>
                </div> */}

                {/* Event Header */}
                <div className="relative z-10 flex items-start gap-4 mb-4">
                  <div className="w-16 h-16 rounded-2xl overflow-hidden bg-gradient-to-br from-gray-100 to-gray-200 flex-shrink-0 border-2 border-white">
                    {program.logo ? (
                      <img
                        src={program.logo}
                        alt="event"
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center">
                        <FiCalendar className="text-gray-400 text-xl" />
                      </div>
                    )}
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-lg font-bold text-gray-900 mb-1 truncate">{program.name}</h3>
                    <p className="text-sm text-gray-600 truncate">TACTOS</p>
                  </div>
                </div>

                {/* Event Details */}
                <div className="relative z-10 space-y-3 mb-4">
                  <div className="flex items-center gap-3 text-sm">
                    <div className="flex items-center gap-2 text-blue-600">
                      <FiTag className="text-xs" />
                      <span className="font-medium">{program.for}</span>
                    </div>
                    
                  </div>

                  <div className="flex items-center gap-2 text-sm text-gray-600">
                    <FiCalendar className="text-green-500 text-xs" />
                    <span>
                    {new Date(program.endDate).toLocaleDateString()}
                    </span>
                  </div>

                    <div className="space-y-2">
                      <div className="flex items-center gap-2 text-sm text-gray-600">
                        <FiMapPin className="text-red-500 text-xs" />
                        <span className="truncate">{program.venue}</span>
                      </div>
                    </div>
                

                </div>

                {/* Description */}
                <div className="relative z-10 mb-6">
                  <p className="text-sm text-gray-600 leading-relaxed">
                    {program?.description?.length > 80 ? `${program.description.slice(0, 80)}...` : program.description}
                  </p>
                </div>

                {/* Action Buttons */}
                <div className="relative z-10 flex flex-wrap gap-2">
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    onClick={() => handleEdit(program)}
                    className="flex items-center gap-1 bg-gradient-to-r from-indigo-500 to-blue-500 text-white px-3 py-2 rounded-lg text-xs font-medium"
                  >
                    <FiEdit3 className="text-xs" />
                    Edit
                  </motion.button>

                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    onClick={() => handleDelete(program._id)}
                    className="flex items-center gap-1 bg-gradient-to-r from-red-500 to-pink-500 text-white px-3 py-2 rounded-lg text-xs font-medium"
                  >
                    <FiTrash2 className="text-xs" />
                    Delete
                  </motion.button>

                  {/* {event.status !== "Completed" && (
                    <motion.button
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                      onClick={() => handleStatusChange(event._id)}
                      className="flex items-center gap-1 bg-gradient-to-r from-green-500 to-emerald-500 text-white px-3 py-2 rounded-lg text-xs font-medium"
                    >
                      <FiCheck className="text-xs" />
                      Complete
                    </motion.button>
                  )} */}

                  {/* <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    onClick={() => navigate(`/registrations/${event._id}`)}
                    className="flex items-center gap-1 bg-gradient-to-r from-purple-500 to-fuchsia-500 text-white px-3 py-2 rounded-lg text-xs font-medium"
                  >
                    <FiUsers className="text-xs" />
                    Registrations
                  </motion.button> */}
                </div>
              </motion.div>
            ))}
          </AnimatePresence>
        </motion.div>

        {/* Empty State */}

        {programs?.data?.length<=0&&(
<motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            className="text-center py-16"
          >
            <div className="w-24 h-24 bg-gradient-to-br from-gray-100 to-gray-200 rounded-3xl flex items-center justify-center mx-auto mb-6">
              <FiCalendar className="text-gray-400 text-3xl" />
            </div>
            <h3 className="text-xl font-semibold text-gray-700 mb-2">No Program found</h3>
            <p className="text-gray-500 mb-6">Create your first Program to get started</p>
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => setShowForm(true)}
              className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-6 py-3 rounded-xl font-semibold"
            >
              Create Program
            </motion.button>
          </motion.div>
        )}
       
          
      
      </div>

      {/* Form Modal  Event Adding*/}
      <AnimatePresence>
        {showForm && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
          >
            <motion.div
              initial={{ opacity: 0, scale: 0.9, y: 20 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.9, y: 20 }}
              className="bg-white rounded-3xl w-full max-w-4xl max-h-[90vh] overflow-auto"
            >
              <div className="sticky top-0 bg-white border-b border-gray-100 p-6 rounded-t-3xl">
                <div className="flex items-center justify-between">
                  <h2 className="text-2xl font-bold bg-gradient-to-r from-gray-900 to-gray-600 bg-clip-text text-transparent">
                    {editIndex !== null ? "Edit Program" : "Create New Program"}
                  </h2>
                  <motion.button
                    whileHover={{ scale: 1.1, rotate: 90 }}
                    whileTap={{ scale: 0.9 }}
                    onClick={() => {
                      setShowForm(false)
                      setEditIndex(null)
                    }}
                    className="w-10 h-10 bg-gray-100 hover:bg-red-100 rounded-full flex items-center justify-center transition-colors duration-300"
                  >
                    <FiX className="text-gray-600 hover:text-red-600" />
                  </motion.button>
                </div>
              </div>

              <form  className="p-6" onSubmit={handleFormSubmit}>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {/* Event Name */}
                  <div className="space-y-2">
                    <label className="text-sm font-semibold text-gray-700">Program Name</label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      placeholder="Enter Program name"
                      className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all duration-300"
                      required
                    />
                  </div>

                  <div className="space-y-2">
                    <label className="text-sm font-semibold text-gray-700">Venue</label>
                    <input
                      type="text"
                      name="venue"
                      value={formData.venue}
                      onChange={handleInputChange}
                      placeholder="Enter Venue"
                      className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all duration-300"
                      required
                    />
                  </div>

                </div>


                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {/* Event Name */}
                  <div className="space-y-2">
                    <label className="text-sm font-semibold text-gray-700">Start Date</label>
                    <input
                      type="date"
                      name="startDate"
                      value={formData.startDate}
                      onChange={handleInputChange}
                      placeholder="Enter Start Date"
                      className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all duration-300"
                      required
                    />
                  </div>

                  <div className="space-y-2">
                    <label className="text-sm font-semibold text-gray-700">End Date</label>
                    <input
                      type="date"
                      name="endDate"
                      value={formData.endDate}
                      onChange={handleInputChange}
                      placeholder="Enter End Date"
                      className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all duration-300"
                      required
                    />
                  </div>

                </div>

                   <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {/* Event Description */}
                  <div className="space-y-2">
                    <label className="text-sm font-semibold text-gray-700">Description</label>
                    <textarea
                      type="text"
                      name="description"
                      value={formData.description}
                      onChange={handleInputChange}
                      placeholder="Enter event Description"
                      className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all duration-300"
                      required
                    />
                  </div>

                  <div className="space-y-2">
                    <label className="text-sm font-semibold text-gray-700">Expiry Date</label>
                    <input
                      type="date"
                      name="expiryDate"
                      value={formData.expiryDate}
                      onChange={handleInputChange}
                      placeholder="Expiry Date"
                      className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all duration-300"
                      required
                    />
                  </div>

                 

                 

                </div>
<div className="grid grid-cols-1  gap-6">
                 <div className="space-y-2">
                    <label className="text-sm font-semibold text-gray-700">Program For</label>
                    <select
                      name="for"
                      value={formData.for}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all duration-300"
                      required
                    >
                    <option value={""} disabled>--</option>
                      <option value="residency">Residency Program</option>
                      <option value="bootcamp">Readiness Bootcamp</option>
                    </select>
                  </div>
</div>
                {/* Submit Button */}
                <div className="mt-8 pt-6 border-t border-gray-100">
                  <motion.button
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                    type="submit"
                    className="w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white py-4 rounded-xl font-semibold text-lg"
                  >
                    {editIndex !== null ? "Update Program" : "Create Program"}
                  </motion.button>
                </div>
              </form>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}

export default Programs
const AdminEventCardSkeleton = () => {
  return (
    <div className="bg-white rounded-3xl p-6 animate-pulse">
      <div className="flex items-start gap-4 mb-4">
        <div className="w-16 h-16 rounded-2xl bg-gray-200" />
        <div className="flex-1 space-y-2">
          <div className="h-4 w-1/2 bg-gray-200 rounded" />
          <div className="h-3 w-2/3 bg-gray-200 rounded" />
        </div>
      </div>

      <div className="space-y-3 mb-4">
        <div className="h-3 w-full bg-gray-200 rounded" />
        <div className="h-3 w-5/6 bg-gray-200 rounded" />
        <div className="h-3 w-4/6 bg-gray-200 rounded" />
      </div>

      <div className="flex gap-2">
        <div className="h-8 w-20 bg-gray-200 rounded-lg" />
        <div className="h-8 w-20 bg-gray-200 rounded-lg" />
        <div className="h-8 w-24 bg-gray-200 rounded-lg" />
      </div>
    </div>
  );
};
